import React from "react";
import { paths } from "./path";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import RequestCancelMeeting from "../customerMeetings/landingPages/requestCancelMeeting/RequestCancelMeeting";
import JoinMeeting from "../customerMeetings/landingPages/joinMeeting/JoinMeeting";

export const Routes: React.FC<{}> = () => {
    return (
        <RouterRoutes>
            <Route path={paths.requestCancelMeeting} element={<RequestCancelMeeting />} />
            <Route path={paths.joinMeeting} element={<JoinMeeting />} />
        </RouterRoutes>
    );
};

export default Routes;
